<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <ContentSection>
    <Container>
      <ClientOnly>
        <!-- HEADER -->
        <h2 v-if="data.heading" class="whitespace-pre-wrap font-semibold typo-h3" v-html="data.heading" />
        <form
          id="displayform"
          action="https://web.inxmail.com/wetrok/subscription/servletv2"
          method="post"
          class="grid max-w-216 grid-cols-4 gap-5 sm:grid-cols-12 sm:gap-6"
        >
          <input
            type="hidden"
            name="INXMAIL_SUBSCRIPTION"
            :value="htmlFields?.INXMAIL_SUBSCRIPTION"
          /><!-- (mandatory) standard list in inxmail -->
          <input
            type="hidden"
            name="INXMAIL_HTTP_REDIRECT"
            :value="htmlFields.INXMAIL_HTTP_REDIRECT"
          /><!-- (mandatory) confirmation landingpage -->
          <input
            type="hidden"
            name="INXMAIL_HTTP_REDIRECT_ERROR"
            :value="htmlFields.INXMAIL_HTTP_REDIRECT_ERROR"
          /><!-- (mandatory) error landingpage -->
          <input
            type="hidden"
            name="INXMAIL_CHARSET"
            value="UTF-8"
          /><!-- (optional) charset of page -->
          <input
            type="hidden"
            name="Sprache"
            :value="htmlFields.Sprache"
          /><!-- (optional) change language, automatic (hidden) -->
          <div class="relative z-10 col-span-12 lg:col-span-4">
            <label for="anrede">Anrede</label>
            <select id="anrede" name="Anrede">
              <option value="">
                Neutral
              </option>
              <option value="m">
                Herr
              </option>
              <option value="f">
                Frau
              </option>
            </select>
          </div>
          <div class="col-span-12 lg:col-span-12">
            <label for="frma">Firma</label>
            <input
              id="firma"
              type="text"
              name="Firma"
            >
          </div>
          <div class="col-span-12 lg:col-span-12">
            <label for="vorname">Vorname</label>
            <input
              id="vorname"
              type="text"
              name="Vorname"
            >
          </div>
          <div class="col-span-12 lg:col-span-12">
            <label for="name">Nachname</label>
            <input
              id="name"
              type="text"
              name="Name"
            >
          </div>
          <div class="col-span-12 lg:col-span-12">
            <label for="email">E-Mail*</label>
            <input
              id="email"
              type="text"
              name="email"
              required
            >
          </div>
          <p class="col-span-12 lg:col-span-12">
            * Pflichtfeld
          </p>
          <div class="col-span-12 mt-3 flex cursor-pointer items-center justify-self-start sm:mt-6">
            <button
              type="submit"
              class="
                g-recaptcha relative flex w-fit min-w-40 cursor-pointer items-center justify-center
                rounded-100 bg-primary-900 font-semibold text-white transition duration-200 ease-in
                typo-subtitle
                active:before:!opacity-0
                before:absolute before:inset-0 before:block before:w-40 before:min-w-40 before:bg-gradient-02
                before:opacity-0 before:transition before:duration-200 before:ease-in
                disabled:pointer-events-none disabled:bg-grey-200 disabled:text-grey-300
                group-hover-focus:duration-300 group-hover-focus:ease-out group-hover-focus:before:opacity-75
                group-hover-focus:before:duration-300 group-hover-focus:before:ease-out
                hover-focus:duration-300 hover-focus:ease-out hover-focus:before:opacity-75
                hover-focus:before:duration-300 hover-focus:before:ease-out
                print:hidden
              "
              data-sitekey="6Ld673sUAAAAANIr4kvsqp3F1i4iiOatKNVWVCL2"
              data-callback="onRecaptchaFormSubmit"
            >
              <span class="relative size-full cursor-pointer px-8 py-3">
                Anmelden
              </span>
            </button>
          </div>
        </form>
      </ClientOnly>
    </Container>
  </ContentSection>
</template>

<!-- eslint-disable-next-line vue/block-lang -->
<script setup>
defineProps({
  data: {
    type: Object,
    required: true,
  },

})

const globals = inject(GlobalsKey, null)
const globalsNewsletter = computed(() => globals?.value?.newsletter)

const { localeProperties } = useI18n()

onMounted(() => {
  // ONLY FOR HTML FORM
  window.onRecaptchaFormSubmit = (_token) => {
    document.getElementById('displayform').submit()
  }
  useHead({
    script: [
      {
        src: 'https://www.google.com/recaptcha/api.js',
        async: true,
        defer: true,
      },
    ],
  })
})

const htmlFields = {}

const { code } = localeProperties.value

switch (code) {
  case 'ch_de':
    htmlFields.INXMAIL_SUBSCRIPTION = 'Newsletter_CH'
    htmlFields.Sprache = 'de'
    break
  case 'ch_fr':
    htmlFields.INXMAIL_SUBSCRIPTION = 'Newsletter_CH'
    htmlFields.Sprache = 'fr'
    break
  case 'ch_it':
    htmlFields.INXMAIL_SUBSCRIPTION = 'Newsletter_CH'
    htmlFields.Sprache = 'it'
    break
  case 'at_de':
    htmlFields.INXMAIL_SUBSCRIPTION = 'Newsletter_AT'
    htmlFields.Sprache = 'de'
    break
  case 'de_de':
    htmlFields.INXMAIL_SUBSCRIPTION = 'Newsletter_DE'
    htmlFields.Sprache = 'de'
    break

  default:
    htmlFields.INXMAIL_SUBSCRIPTION = 'Newsletter_CH'
    htmlFields.Sprache = 'de'
}

htmlFields.INXMAIL_HTTP_REDIRECT = globalsNewsletter.value?.subscription_success_entry?.permalink
htmlFields.INXMAIL_HTTP_REDIRECT_ERROR = globalsNewsletter.value?.subscription_error_entry?.permalink
</script>

<style scoped>
label {
  @apply mb-2 block text-grey-300 typo-subtitle;
}

select {
  @apply  w-full border-b bg-grey-100 p-4 focus:border-black rounded-none;
  appearance: base-select;
}

input[type='text'] {
  @apply w-full border-b bg-grey-100 p-4 focus:border-black;
}
</style>

<gql component>
  heading
</gql>
